var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgUserIcon = function SvgUserIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon name=User"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2216 25.6525C25.0962 25.6525 29.0478 21.7008 29.0478 16.8262C29.0478 11.9516 25.0962 8 20.2216 8C15.347 8 11.3954 11.9516 11.3954 16.8262C11.3954 21.7008 15.347 25.6525 20.2216 25.6525Z",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 32C9.37848 30.0392 11.2085 28.4389 13.3355 27.3341C15.4626 26.2294 17.8242 25.6526 20.2211 25.6525C22.6179 25.6524 24.9796 26.229 27.1067 27.3336C29.2339 28.4382 31.064 30.0384 32.4426 31.9991",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgUserIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgNDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJJY29uIG5hbWU9VXNlciI+CjxnIGlkPSJHcm91cCA1MjIiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMjAuMjIxNiAyNS42NTI1QzI1LjA5NjIgMjUuNjUyNSAyOS4wNDc4IDIxLjcwMDggMjkuMDQ3OCAxNi44MjYyQzI5LjA0NzggMTEuOTUxNiAyNS4wOTYyIDggMjAuMjIxNiA4QzE1LjM0NyA4IDExLjM5NTQgMTEuOTUxNiAxMS4zOTU0IDE2LjgyNjJDMTEuMzk1NCAyMS43MDA4IDE1LjM0NyAyNS42NTI1IDIwLjIyMTYgMjUuNjUyNVoiIHN0cm9rZT0iIzA1NEJDNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik04IDMyQzkuMzc4NDggMzAuMDM5MiAxMS4yMDg1IDI4LjQzODkgMTMuMzM1NSAyNy4zMzQxQzE1LjQ2MjYgMjYuMjI5NCAxNy44MjQyIDI1LjY1MjYgMjAuMjIxMSAyNS42NTI1QzIyLjYxNzkgMjUuNjUyNCAyNC45Nzk2IDI2LjIyOSAyNy4xMDY3IDI3LjMzMzZDMjkuMjMzOSAyOC40MzgyIDMxLjA2NCAzMC4wMzg0IDMyLjQ0MjYgMzEuOTk5MSIgc3Ryb2tlPSIjMDU0QkM3IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPC9nPgo8L3N2Zz4K";